import { useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

import Routes from "Routes";

import CommonTheme from "Styles/Themes/common";
import GlobalStyle from "Styles/global";

import AppConfigProvider from "Contexts/AppConfig";
import AuthProvider from "Contexts/Auth";
import FileProvider from "Contexts/File";
import GlobalConfirmProvider from "Contexts/GlobalConfirmContext";
import { GlobalLoadingProvider } from "Contexts/GlobalLoading";
import LayoutProvider from "Contexts/Layout";
import ModalProvider from "Contexts/Modal";
import NotificationProvider from "Contexts/Notification";
import ServicesProvider from "Contexts/Services";
import { TwoFactorAuthenticationProvider } from "Contexts/TwoFactorAuthentication";

import useVersionCheck from "Hooks/useVersionCheck";

import EnvironmentBanner from "Components/Global/EnvironmentBanner";
import GlobalConfirm from "Components/Global/Modals/Confirm";

import { ThemeProvider } from "styled-components";

const App = () => {
  const [render, setRender] = useState(false);
  const [theme, setTheme] = useState(CommonTheme);

  useVersionCheck();

  return (
    <ThemeProvider theme={theme}>
      <ReactNotifications />
      <GlobalConfirmProvider>
        <GlobalLoadingProvider render={render} setRender={setRender}>
          <ServicesProvider>
            <ModalProvider>
              <AuthProvider
                loading={render}
                setLoading={setRender}
                setTheme={setTheme}
              >
                <TwoFactorAuthenticationProvider>
                  <NotificationProvider>
                    <AppConfigProvider>
                      <FileProvider>
                        <LayoutProvider>
                          <GlobalConfirm />
                          <GlobalStyle />
                          <EnvironmentBanner />
                          <Routes setTheme={setTheme} />
                        </LayoutProvider>
                      </FileProvider>
                    </AppConfigProvider>
                  </NotificationProvider>
                </TwoFactorAuthenticationProvider>
              </AuthProvider>
            </ModalProvider>
          </ServicesProvider>
        </GlobalLoadingProvider>
      </GlobalConfirmProvider>
    </ThemeProvider>
  );
};

export default App;
